<template>
    <div
            style="margin-top: 15px; margin-bottom: 45px;"
    >
        <v-card
                :color="dark ? 'primary' : ''"
                :dark="dark"
        >
            <v-card-text class="relative pb-0">
                <div
                        class="relative shift-up elevation-6 w-full py-1 px-1 top-right-rounded rounded white--text"
                        :class="'bg-' + color"
                >
                    <span
                            class="text-uppercase oswald-font-family title"
                            v-html="title"
                    ></span>
                </div>
                <div
                        style="margin-top: -30px;"
                >
                    <slot></slot>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
    export default {
        data() {
            return {}
        },

        props: {
            'title': {
                type: String,
                default: ''
            },
            'color': {
                type: String,
                default: 'primary'
            },
            'dark': {
                type: Boolean,
                default: false
            }
        }
    }
</script>